import { render, staticRenderFns } from "./MockupSelector.vue?vue&type=template&id=385becb8&scoped=true"
import script from "./MockupSelector.vue?vue&type=script&lang=js"
export * from "./MockupSelector.vue?vue&type=script&lang=js"
import style0 from "./MockupSelector.vue?vue&type=style&index=0&id=385becb8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385becb8",
  null
  
)

export default component.exports